import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Box,
  Tooltip,
} from "@mui/material";
import {
  Button,
  useNotify,
  useCreate,
  BooleanInput,
  SelectArrayInput,
  ReferenceArrayInput,
  ReferenceInput,
  SelectInput,
  FormDataConsumer,
  SaveButton,
  useUpdate,
  useGetOne,
  Form,
} from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
// import SaveIcon from "@mui/icons-material/Save";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

interface IMyProps {
  arrayItens: any[];
}

const ScmAnalysesDialog = ({ sku }: { sku: number }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [update] = useUpdate();
  const notify = useNotify();

  // const codigoSku = sku;
  // console.log("showDialog", showDialog);

  // Get Para pegar os dados para o PUT
  const { data, error } = useGetOne(
    "products",
    { id: sku },
    { enabled: showDialog },
  );

  const handleClick = (event?: React.MouseEvent) => {
    event?.stopPropagation();
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const optionSkuGroupsRenderer = (choice: any) =>
    `${choice.codigo_agrup}. ${choice.desc_agrupamento}`;

  const handleSubmit = async (dados: any) => {
    // Concatenei os tags, após preparo para envio
    const listaConcatTags = [
      data?.ids_tags || [],
      dados?.ids_tags_add || [],
    ].flat();

    const listaTags = listaConcatTags.filter(
      (tag) => !(dados?.ids_tags_rem || []).includes(tag),
    );

    var dadosPUT = {
      ...data, //Aqui envia os dados do GETone Já feito
      ids_tags: listaTags,
      // ativo: dados.ativo,
      zerar: {
        sazo: dados.sazo,
        camp: dados.camp,
        cmmf: dados.cmmf,
      },
    };

    await update(
      "products",
      {
        id: data.id,
        data: dadosPUT,
      },
      {
        onSuccess: () => {
          notify("Item atualizado");
        },
        onError: (response) => {
          notify(response?.message || "Erro desconhecido", { type: "error" });
        },
      },
    );
  };

  return (
    <>
      <Button
        onClick={handleClick}
        onMouseDown={(event) => event.stopPropagation()}
        label=""
        sx={{
          margin: 0,
          padding: 0,
          minWidth: "auto",
        }}
      >
        <EditIcon />
      </Button>
      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label="Create post"
        maxWidth="sm"
      >
        <Form onSubmit={handleSubmit}>
          <DialogTitle>Edição de Itens</DialogTitle>
          <DialogContent>
            <Stack display={{ md: "block", lg: "flex" }}>
              <Box mr={{ sm: "0.5em" }}>
                <ReferenceArrayInput
                  source="ids_tags_add"
                  // source="ids_tags"
                  reference="producttags"
                  perPage={1000}
                  sort={{ field: "nome_tag", order: "ASC" }}
                  fullWidth
                >
                  <SelectArrayInput
                    optionText="nome_tag"
                    label="Adicionar Tags"
                  />
                </ReferenceArrayInput>
              </Box>
              <Box mr={{ sm: "0.5em" }}>
                <ReferenceArrayInput
                  source="ids_tags_rem"
                  reference="producttags"
                  perPage={1000}
                  sort={{ field: "nome_tag", order: "ASC" }}
                  fullWidth
                >
                  <SelectArrayInput
                    optionText="nome_tag"
                    label="Remover Tags"
                  />
                </ReferenceArrayInput>
              </Box>
              <Box display={{ md: "block", lg: "flex" }}>
                <Box flex={3} mr={{ sm: "0.5em" }}>
                  <ReferenceInput
                    resource="products"
                    source="id_agrup"
                    reference="skugroups"
                    perPage={100}
                    sort={{ field: "id", order: "ASC" }}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  >
                    <SelectInput
                      optionText={optionSkuGroupsRenderer}
                      label="Argumento Comercial"
                      InputLabelProps={{ shrink: true }}
                    />
                  </ReferenceInput>
                </Box>
                {/* <Box flex={1}>
                  <BooleanInput
                    source="ativo"
                    fullWidth
                    sx={{ marginTop: "1em" }}
                  />
                </Box> */}
              </Box>

              <Box
                display={{
                  xs: "block",
                  sm: "flex",
                }}
              >
                <Box mr={{ sm: "0em" }}>
                  <BooleanInput
                    source="zerar_todos"
                    label="Zerar Dados Suprimento"
                  />
                </Box>
                <Box flex="1">
                  <Tooltip
                    title="Selecionar quais dados de suprimento (SAZO, CAMP e CMMF) serão
                zerados em todas as empresas para esse SKU."
                    placement="right"
                    arrow
                  >
                    <HelpOutlineIcon
                      //marginTop: "1em",
                      sx={{ fontSize: "small" }}
                    />
                  </Tooltip>
                </Box>
              </Box>
              <Box
                display={{
                  xs: "block",
                  sm: "flex",
                }}
              >
                <FormDataConsumer>
                  {({ formData }) =>
                    formData.zerar_todos && (
                      <Box
                        display={{
                          xs: "block",
                          sm: "flex",
                        }}
                      >
                        <Box flex="1" mr={{ sm: "0.5em" }}>
                          <BooleanInput source="sazo" />
                        </Box>
                        <Box flex="1" mr={{ sm: "0.5em" }}>
                          <BooleanInput source="camp" />
                        </Box>
                        <Box flex="1">
                          <BooleanInput source="cmmf" label="CMMF" />
                        </Box>
                      </Box>
                    )
                  }
                </FormDataConsumer>
              </Box>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button label="Cancelar" onClick={handleCloseClick} />
            <SaveButton type="submit" />
            {/* <SaveButton onClick={() => handleSubmit(params?.data)} /> */}
          </DialogActions>
        </Form>
      </Dialog>
    </>
  );
};

export default ScmAnalysesDialog;
